import React, { Fragment } from 'react';
import {
  get, startCase, pick, isEqual,
} from 'lodash';

import { env } from '~/commons/config';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { countryObj } from './commons';

const isEqualProps = (prevProps, nextProps) => {
  const prevAddress = pick(prevProps.formData, ['billingAddress', 'shippingAddress']);
  const nextAddress = pick(nextProps.formData, ['billingAddress', 'shippingAddress']);

  return isEqual(prevAddress, nextAddress);
};

const FieldAddresses = ({ formData, disabled }) => (
    <>
      {['billingAddress', 'shippingAddress'].map((v, i) => (
        <Fragment key={i}>
          <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">
            {startCase(v)}
          </h6>
          <div className="card mb-3">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <FormGroup name={`${v}.address1`} label="Address 1" disabled={disabled} />
                </div>
                <div className="col">
                  <FormGroup name={`${v}.address2`} label="Address 2" disabled={disabled} />
                </div>
                <div className="col">
                  <FormGroup name={`${v}.address3`} label="Address 3" disabled={disabled} />
                </div>
                <div className="col">
                  <FormGroup name={`${v}.address4`} label="Address 4" disabled={disabled} />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name={`${v}.city`} label="City" disabled={disabled} />
                </div>
                <div className="col">
                  <FormGroup name={`${v}.state`} label="State" as="select" disabled={disabled}>
                    <option value=""> - </option>
                    {env.stateCode.map((x) => (
                      <option value={x.code} key={x.code}>
                        {x.code} - {x.name}
                      </option>
                    ))}
                  </FormGroup>
                </div>
                {get(formData, `${v}.countryCode`) === 'US' ? (
                  <div className="col">
                    <FormGroup name={`${v}.county`} label="County" disabled={disabled} />
                  </div>
                ) : (
                  <div className="col">
                      <FormGroup name={`${v}.province`} label="Province" disabled={disabled} />
                  </div>
                )}
                <div className="col">
                  <FormGroup
                    name={`${v}.countryCode`}
                    label="Country"
                    value={countryObj[get(formData, `${v}.countryCode`)] || ''}
                    onChange={() => {}}
                    disabled
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <FormGroup name={`${v}.postCode`} label="Post Code" disabled={disabled} />
                </div>
                <div className="col">
                  <FormGroup
                    name={`${v}.countryCode`}
                    label="Country Code"
                    as="select"
                    disabled={disabled}>
                    <option value=""> - </option>
                    {env.countryCode.map((x) => (
                      <option value={x.code} key={x.code}>
                        {x.code} - {x.short}
                      </option>
                    ))}
                  </FormGroup>
                </div>
                <div className="col">
                  <FormGroup name={`${v}.remarks`} label="Remark" disabled={disabled} />
                </div>
                <div className="col">
                  <FormGroup name={`${v}.erpId`} label="ERP ID" disabled={disabled || !!formData?.refCode} />
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ))}
    </>
);

export default React.memo(FieldAddresses, isEqualProps);
